import { Entity } from '@/store/shared/entity'

export default class DomesticSalesProfit extends Entity<number>{
    shippingNumber: string;
    shipmentDate: Date;
    customerName: string;
    ownerName: string;
    businessGroup: string;
    receiverAmount: number;
    factoryName: Array<any> = new Array<any>();
    factoryAmount: number;
    freight: number;
    invoiceTax: number;
    amountReceivedRMB: number;
    bankCharges: number;
    profitType: string;
    profit: number;
    profitMargin: number;
    remark: string;
    shipmentDateStr:string;


}